var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAddCard = function SvgAddCard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.875 3.625a3.75 3.75 0 0 0-3.75 3.75v7a3.75 3.75 0 0 0 3.75 3.75h6.87a6.467 6.467 0 0 1-.632-1.5H4.875a2.25 2.25 0 0 1-2.25-2.25v-7a2.25 2.25 0 0 1 2.25-2.25h13a2.25 2.25 0 0 1 2.25 2.25v1.609c.546.255 1.05.583 1.5.973V7.375a3.75 3.75 0 0 0-3.75-3.75h-13Z",
    fill: "#666"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.584 11.768h-5.87a.697.697 0 1 1 0-1.392h5.87a.697.697 0 0 1 0 1.392ZM8.89 14.514H4.715a.697.697 0 1 1 0-1.392h4.177a.697.697 0 0 1 0 1.392ZM22.875 14.875a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0Zm-4.889-2.444a.611.611 0 1 0-1.222 0v1.833H14.93a.611.611 0 1 0 0 1.222h1.833v1.833a.611.611 0 1 0 1.222 0v-1.833h1.833a.611.611 0 1 0 0-1.222h-1.833V12.43Z",
    fill: "#666"
  })));
};
export default SvgAddCard;